module.exports = __webpack_public_path__ + "img/payment-terminal.907f407e.webp";